export default __webpack_public_path__ + "static/media/icon-mobile-app.8ac964b9.png";